import {SegmentInfo} from '../types/SegmentInfo';

export class SegmentTracker {
  protected segments: SegmentInfo[];

  constructor() {
    this.segments = [];
  }

  reset(): void {
    this.segments = [];
  }

  addSegment(segment: SegmentInfo): void {
    this.segments.push(segment);
  }

  removeSegment(url: string): void {
    this.segments = this.segments.filter((s) => s.url !== url);
  }

  getSegments(): SegmentInfo[] {
    return this.segments;
  }
}
